<template>
  <div>
    <el-button
      v-if="effectivePublish"
      size="mini"
      type="text"
      @click="handleUnpublish(row, index)"
      style="color: red;"
      >停止</el-button
    >
    <el-button v-else size="mini" type="text" @click="handlePublish(row, index)"
      >发布</el-button
    >
    <el-divider direction="vertical"></el-divider>
    <el-button size="mini" type="text" @click="handleShare(row, index)"
      >分享</el-button
    >
    <el-divider direction="vertical"></el-divider>
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <el-button size="mini" type="text">更多</el-button>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="effectivePublish || row.type === 2"
          icon="el-icon-edit"
          :command="{
            type: 'edit',
            row: row,
            index: index,
          }"
          style="color: #e9e9eb;"
          >编辑</el-dropdown-item
        >
        <el-dropdown-item
          v-else
          icon="el-icon-edit"
          :command="{
            type: 'edit',
            row: row,
            index: index,
          }"
          >编辑</el-dropdown-item
        >
        <el-dropdown-item
          v-if="row.type === 2"
          icon="el-icon-data-line"
          :command="{
            type: 'count',
            row: row,
            index: index,
          }"
          style="color: #e9e9eb;"
          >统计</el-dropdown-item
        >
        <el-dropdown-item
          v-else
          icon="el-icon-data-line"
          :command="{
            type: 'count',
            row: row,
            index: index,
          }"
          >统计</el-dropdown-item
        >
        <el-dropdown-item
          icon="el-icon-delete"
          :command="{
            type: 'delete',
            row: row,
            index: index,
          }"
          >删除</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import {
  Button,
  Divider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "element-ui";

export default {
  name: "operator-column",
  components: {
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  props: {
    row: Object,
    index: Number,
  },
  computed: {
    effectivePublish() {
      const { published, effective, expired } = this.$props.row || {};
      return published && effective && !expired;
    },
  },
  methods: {
    handlePublish(row) {
      this.$emit("publish", row);
    },
    handleUnpublish(row) {
      this.$emit("unpublish", row);
    },
    handleShare(row) {
      this.$emit("share", row);
    },
    handleCommand({ type, row }) {
      this.$emit("command", { type, row });
    },
  },
};
</script>
